import { computed } from 'vue';
import { RoleType as RT } from '@botc/shared';
// Vollstaendige Rollendaten fuer Trouble Brewing
const rolesData = [
    // === TOWNSFOLK (13) ===
    {
        id: 'washerwoman',
        type: RT.TOWNSFOLK,
        nameKey: 'roles.washerwoman.name',
        descriptionKey: 'roles.washerwoman.description',
        abilityKey: 'roles.washerwoman.ability',
        rulesKeys: ['rules.washerwoman.1', 'rules.washerwoman.2'],
        firstNightOrder: 23,
        reminders: ['Townsfolk', 'Wrong'],
    },
    {
        id: 'librarian',
        type: RT.TOWNSFOLK,
        nameKey: 'roles.librarian.name',
        descriptionKey: 'roles.librarian.description',
        abilityKey: 'roles.librarian.ability',
        rulesKeys: ['rules.librarian.1', 'rules.librarian.2'],
        firstNightOrder: 24,
        reminders: ['Outsider', 'Wrong'],
    },
    {
        id: 'investigator',
        type: RT.TOWNSFOLK,
        nameKey: 'roles.investigator.name',
        descriptionKey: 'roles.investigator.description',
        abilityKey: 'roles.investigator.ability',
        rulesKeys: ['rules.investigator.1', 'rules.investigator.2'],
        firstNightOrder: 25,
        reminders: ['Minion', 'Wrong'],
    },
    {
        id: 'chef',
        type: RT.TOWNSFOLK,
        nameKey: 'roles.chef.name',
        descriptionKey: 'roles.chef.description',
        abilityKey: 'roles.chef.ability',
        rulesKeys: ['rules.chef.1'],
        firstNightOrder: 26,
        reminders: [],
    },
    {
        id: 'empath',
        type: RT.TOWNSFOLK,
        nameKey: 'roles.empath.name',
        descriptionKey: 'roles.empath.description',
        abilityKey: 'roles.empath.ability',
        rulesKeys: ['rules.empath.1'],
        firstNightOrder: 27,
        otherNightOrder: 37,
        reminders: [],
    },
    {
        id: 'fortuneteller',
        type: RT.TOWNSFOLK,
        nameKey: 'roles.fortuneteller.name',
        descriptionKey: 'roles.fortuneteller.description',
        abilityKey: 'roles.fortuneteller.ability',
        rulesKeys: ['rules.fortuneteller.1', 'rules.fortuneteller.2'],
        firstNightOrder: 28,
        otherNightOrder: 38,
        reminders: ['Red Herring'],
    },
    {
        id: 'undertaker',
        type: RT.TOWNSFOLK,
        nameKey: 'roles.undertaker.name',
        descriptionKey: 'roles.undertaker.description',
        abilityKey: 'roles.undertaker.ability',
        rulesKeys: ['rules.undertaker.1'],
        otherNightOrder: 39,
        reminders: ['Executed'],
    },
    {
        id: 'monk',
        type: RT.TOWNSFOLK,
        nameKey: 'roles.monk.name',
        descriptionKey: 'roles.monk.description',
        abilityKey: 'roles.monk.ability',
        rulesKeys: ['rules.monk.1'],
        otherNightOrder: 12,
        reminders: ['Protected'],
    },
    {
        id: 'ravenkeeper',
        type: RT.TOWNSFOLK,
        nameKey: 'roles.ravenkeeper.name',
        descriptionKey: 'roles.ravenkeeper.description',
        abilityKey: 'roles.ravenkeeper.ability',
        rulesKeys: ['rules.ravenkeeper.1'],
        otherNightOrder: 40,
        reminders: [],
    },
    {
        id: 'virgin',
        type: RT.TOWNSFOLK,
        nameKey: 'roles.virgin.name',
        descriptionKey: 'roles.virgin.description',
        abilityKey: 'roles.virgin.ability',
        rulesKeys: ['rules.virgin.1'],
        reminders: ['No Ability'],
    },
    {
        id: 'slayer',
        type: RT.TOWNSFOLK,
        nameKey: 'roles.slayer.name',
        descriptionKey: 'roles.slayer.description',
        abilityKey: 'roles.slayer.ability',
        rulesKeys: ['rules.slayer.1'],
        reminders: ['No Ability'],
    },
    {
        id: 'soldier',
        type: RT.TOWNSFOLK,
        nameKey: 'roles.soldier.name',
        descriptionKey: 'roles.soldier.description',
        abilityKey: 'roles.soldier.ability',
        rulesKeys: ['rules.soldier.1'],
        reminders: [],
    },
    {
        id: 'mayor',
        type: RT.TOWNSFOLK,
        nameKey: 'roles.mayor.name',
        descriptionKey: 'roles.mayor.description',
        abilityKey: 'roles.mayor.ability',
        rulesKeys: ['rules.mayor.1'],
        reminders: [],
    },
    // === OUTSIDER (4) ===
    {
        id: 'butler',
        type: RT.OUTSIDER,
        nameKey: 'roles.butler.name',
        descriptionKey: 'roles.butler.description',
        abilityKey: 'roles.butler.ability',
        rulesKeys: ['rules.butler.1', 'rules.butler.2'],
        firstNightOrder: 29,
        reminders: ['Master'],
    },
    {
        id: 'drunk',
        type: RT.OUTSIDER,
        nameKey: 'roles.drunk.name',
        descriptionKey: 'roles.drunk.description',
        abilityKey: 'roles.drunk.ability',
        rulesKeys: ['rules.drunk.1', 'rules.drunk.2'],
        setupReminder: 'Is the Drunk',
        reminders: [],
    },
    {
        id: 'recluse',
        type: RT.OUTSIDER,
        nameKey: 'roles.recluse.name',
        descriptionKey: 'roles.recluse.description',
        abilityKey: 'roles.recluse.ability',
        rulesKeys: ['rules.recluse.1'],
        reminders: [],
    },
    {
        id: 'saint',
        type: RT.OUTSIDER,
        nameKey: 'roles.saint.name',
        descriptionKey: 'roles.saint.description',
        abilityKey: 'roles.saint.ability',
        rulesKeys: ['rules.saint.1'],
        reminders: [],
    },
    // === MINION (4) ===
    {
        id: 'poisoner',
        type: RT.MINION,
        nameKey: 'roles.poisoner.name',
        descriptionKey: 'roles.poisoner.description',
        abilityKey: 'roles.poisoner.ability',
        rulesKeys: ['rules.poisoner.1', 'rules.poisoner.2'],
        firstNightOrder: 17,
        otherNightOrder: 7,
        reminders: ['Poisoned'],
    },
    {
        id: 'spy',
        type: RT.MINION,
        nameKey: 'roles.spy.name',
        descriptionKey: 'roles.spy.description',
        abilityKey: 'roles.spy.ability',
        rulesKeys: ['rules.spy.1', 'rules.spy.2'],
        firstNightOrder: 30,
        otherNightOrder: 41,
        reminders: [],
    },
    {
        id: 'scarletwoman',
        type: RT.MINION,
        nameKey: 'roles.scarletwoman.name',
        descriptionKey: 'roles.scarletwoman.description',
        abilityKey: 'roles.scarletwoman.ability',
        rulesKeys: ['rules.scarletwoman.1', 'rules.scarletwoman.2'],
        otherNightOrder: 18,
        reminders: ['Is the Demon'],
    },
    {
        id: 'baron',
        type: RT.MINION,
        nameKey: 'roles.baron.name',
        descriptionKey: 'roles.baron.description',
        abilityKey: 'roles.baron.ability',
        rulesKeys: ['rules.baron.1'],
        setupReminder: '+2 Outsiders',
        reminders: [],
    },
    // === DEMON (1) ===
    {
        id: 'imp',
        type: RT.DEMON,
        nameKey: 'roles.imp.name',
        descriptionKey: 'roles.imp.description',
        abilityKey: 'roles.imp.ability',
        rulesKeys: ['rules.imp.1', 'rules.imp.2', 'rules.imp.3'],
        firstNightOrder: 0,
        otherNightOrder: 24,
        reminders: ['Dead'],
    },
];
/**
 * Composable fuer Rollen-Verwaltung
 */
export function useRoles() {
    const roles = computed(() => rolesData);
    function getRoleById(id) {
        return rolesData.find(role => role.id === id);
    }
    function getRolesByType(type) {
        return rolesData.filter(role => role.type === type);
    }
    return {
        roles,
        getRoleById,
        getRolesByType,
    };
}
